// Mobile nav: the desktop links are hidden below `md`; this panel drops down
// under the header. It is a normal in-flow element (not position:fixed), so
// it can never be trapped by an ancestor's containing block.
const trigger = document.querySelector("[data-mobile-menu-trigger]")
const menu = document.querySelector("[data-mobile-menu]")

if (trigger && menu) {
  const setOpen = (open) => {
    menu.hidden = !open
    trigger.setAttribute("aria-expanded", String(open))
    trigger.querySelector("[data-icon-open]").hidden = open
    trigger.querySelector("[data-icon-close]").hidden = !open
  }
  trigger.addEventListener("click", () => setOpen(menu.hidden))
  menu.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => setOpen(false)))
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !menu.hidden) setOpen(false)
  })
}
